module.exports = __webpack_public_path__ + "img/newvlaps.42616625.png";